import { render, staticRenderFns } from "./App.vue?vue&type=template&id=27a2de68"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=27a2de68&prod&lang=css"


/* normalize component */
import normalizer from "!../.yarn/__virtual__/vue-loader-virtual-f7f1a7d01b/5/C:/Users/Administrator/AppData/Local/Yarn/Berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports